import { sample } from 'effector';
import { getUserInfoEv, loginEv, logoutEv, setAuthEv } from './events.js';
import { getUserInfoFx, loginFx, logoutFx } from './effects.js';
import { $authStatus, $userInfo } from './stores.js';
import { cookies } from '../../api/axiosinstance.js';

$authStatus
  .on(loginFx.doneData, (_, payload) => {
    cookies.set('access_token', payload.object.result.token);
    return true;
  })
  .on(setAuthEv, (_, payload) => payload)
  .on(logoutFx.doneData, (_, payload) => false);

$userInfo.on(getUserInfoFx.doneData, (_, payload) => payload.object.result);

sample({
  clock: loginEv,
  target: loginFx,
});

sample({
  clock: logoutEv,
  target: logoutFx,
});

sample({
  clock: getUserInfoEv,
  target: getUserInfoFx,
});

logoutFx.doneData.watch(() => {
  cookies.remove('access_token');
  window.location.replace('/login');
});
